export enum PathNames {
    ROOT = '/',
    SUMMARY = '/summary',
    YOUR_DETAILS = '/your-details',
    ROOMMATES = '/roommates',
    AGREEMENTS = '/agreements',
    BOOKING_DETAILS = '/booking-details',
    SUCCESS = '/success',
    SUCCESS_ORIA = '/success-oria',
    PAYMENT_SUCCESSFUL = '/payment-successful',
    FAILURE = '/failure',
    ABORTED = '/aborted',
    PROCESSING = '/processing',
    PROCESSING_AMEND = '/processing/amend',
    CALLBACK = '/callback',
    BROCHURE_CALLBACK = '/brochure-callback',
    DUAL_OCCUPANT_CALLBACK = '/callback/occupant',
    AMEND_BOOKING_CALLBACK = '/callback/amend',
    AMEND_BOOKING_CALLBACK_DUAL_OCCUPANT = '/callback/amend/occupant',
    AMEND_BOOKING = '/amend',
    AMEND_BOOKING_SUMMARY = '/amend/summary',
    AMEND_BOOKING_DUAL_OCCUPANT = '/amend/occupant/details',
    OCCUPANT = '/occupant',
    OCCUPANT_PASSWORD = '/occupant/password',
    OCCUPANT_DETAILS = '/occupant/details',
    LOGOUT = '/logout',
    ROOM_NOT_AVAILABLE = '/room-not-available',
    NO_ROOM_SELECTED = '/no-room-selected',
    BOOKING_UPDATED = '/booking-updated',
    BOOKING_UPDATE_FAILURE = '/update-failure',
    BOOKING_UPDATE_EXPIRED = '/update-expired',
    NOT_FOUND = '/not-found',
    MAKE_A_PAYMENT = '/make-a-payment',
    RESET_PASSWORD = '/auth/reset-password',
}
